<template>
  <li
    v-if="link"
    :style="{ gridArea: link.type }"
    @click="handleClick($event)"
    @mouseenter="showHideElement($refs.copy, true)"
    @mouseleave="showHideElement($refs.copy, false)"
  >
    <a class="nav-link" :href="link.url">
      <span
        :style="{ color: tooltipColor }"
        v-if="link.type === 'email'"
        ref="tooltip"
        class="tool-tip-text"
      >
        {{ tooltipText }}
      </span>
      <component :is="link.type"></component>
    </a>
    <a ref="copy" class="hidden" :href="`mailto:${link.url}`">
      {{ link.name }}
    </a>
    <input type="text" :value="link.name" ref="copyFail" />
  </li>
</template>

<script>
  import email from '@/assets/icons/email.vue'
  import linkedin from '@/assets/icons/linkedin'
  import github from '@/assets/icons/github.vue'
  export default {
    components: {
      email,
      github,
      linkedin
    },
    data() {
      return {
        email: email,
        linkedin,
        github,
        isClicked: false,
        tooltipText: 'Click to copy',
        clipBoard: '',
        isFirefox: typeof InstallTrigger !== 'undefined',
        isChrome:
          !!window.chrome &&
          (!!window.chrome.webstore || !!window.chrome.runtime),
        tooltipColor: 'white'
      }
    },

    props: {
      link: {
        type: Object,
        required: false,
        default: () => {}
      }
    },
    mounted() {
      const getHexColor = color => {
        if (typeof color == 'number') {
          return '#' + ('00000' + color.toString()).slice(-6)
        } else return color
      }
      this.tooltipColor = getHexColor(this.$store.state.canvasBgColor)
    },
    methods: {
      setClipboard(text) {
        let data = new DataTransfer()
        data.items.add('text/plain', text)
        const vm = this
        navigator.clipboard.writeText(data.items[0].type).then(
          function() {
            vm.isClicked = !vm.isClicked
            vm.tooltipText = 'Copied!'
          },
          function() {
            vm.isClicked = !vm.isClicked
          }
        )
      },

      handleClick(e) {
        if (this.link.type === 'email') {
          e.preventDefault()
          if (!this.isFirefox && !this.isChrome) {
            this.$refs.copyFail.select()
            document.execCommand('copy')
            this.tooltipText = 'Copied!'
            return
          }
          const data = new DataTransfer()
          data.items.add('text/plain', this.$refs.copy.innerText)
          this.setClipboard(this.$refs.copy.innerText)
        }
      },

      showHideElement(element, show) {
        element.classList.toggle('show', show)
        const tooltip = this.$refs.tooltip
        if (show) {
          if (tooltip) {
            tooltip.style.opacity = 1
            tooltip.style.visibility = 'visible'
          }
        } else {
          if (tooltip) {
            tooltip.style.opacity = 0
            tooltip.style.visibility = 'hidden'
          }
          window.setTimeout(() => {
            this.isClicked = false
            element.style.removeProperty('height')
          }, 7)
          window.setTimeout(() => {
            //to persist the 'copied' until  the tool tip is not visible
            this.tooltipText = 'Click To Copy'
          }, 500)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hidden {
    display: inline-block;
    color: transparent;
    font-weight: 500;
    margin-top: 0.5rem;
    overflow: hidden;
    transition: color 0.25s ease-out;
  }

  .hidden.show {
    color: $primary;
  }

  li {
    display: flex;
    text-align: center;
    flex-direction: column;
  }

  a.hidden {
    border: none;
    overflow: auto;
    padding: 0;
    resize: none;
    cursor: pointer;
  }

  a.nav-link {
    .tool-tip-text {
      width: 120px;
      background-color: rgba(255, 255, 255, 0.4);
      text-align: center;
      border-radius: 6px;
      font-weight: 500;
      padding: 5px 0;
      position: absolute;
      letter-spacing: 0.5px;
      bottom: 125%;
      left: 50%;
      margin-left: -60px;
      opacity: 0;
      transition: 0.4s ease;

      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.4) transparent transparent
          transparent;
      }
    }

    position: relative;
    display: inline-block;
    vertical-align: middle;
  }

  input {
    border: none;
    padding: 0;
    margin: 0;
    height: 1px;
    width: 1px;
    opacity: 0;
  }
</style>
